import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListQuanLyThuChiHopDong,
  updateDataSearch,
} from "../../../actions/QuanLyThuChiHopDong";
import { formatNumber } from "utils/currencyFormat";
import { formatCurrency2 } from "utils/currencyFormat";
import useHinhThucThanhToan from "utils/useHinhThucThanhToan";

export const TableDanhSach = ({
  daDoc,
  inPhieuChi,
  inPhieuThu,
  suaPhieu,
  xoaPhieu,
  isHoaHongTraGop,
  isDuDungPhiPhatDongLaiTatToan,
  isSuDungPhiPhatDongLaiCham,
  SuDungTatToanSom,
  isWinmoney,
}) => {
  const dispatch = useDispatch();
  const batHinhThucThanhToan = useHinhThucThanhToan();
  const listQuanLyThuChiHopDongFull = useSelector(
    (state) => state.listQuanLyThuChiHopDongFull
  ); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong
  ); //dataSearchTaiSan dinh nghia o rootreducer
  useEffect(() => {
    dispatch(getListQuanLyThuChiHopDong(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListQuanLyThuChiHopDong(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListQuanLyThuChiHopDong(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const TotalQuantity = listQuanLyThuChiHopDongFull.TotalQuantity;

  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
          marginTop: "-35px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new tableFix">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listQuanLyThuChiHopDongFull.getListQuanLyThuChiHopDongLoading
                    ? "is-active"
                    : "")
                }
              ></div>
            </div>
            <div className="table-mobile table-mobile-hover table-responsive-new ">
              <div className="custom-table-wrapper">
                <div
                  className="table-headers-v2   hidden-mobile-main "
                  style={{
                    position: "sticky",
                    padding: "2px",
                    top: "0rem",
                    zIndex: "999",
                    background: "#FFFFFF",
                    padding: "1px 0",
                  }}
                >
                  <div className="custom-table-header flex-basis-5 flex-mobile-5">
                    <p className="text-center color-do-bold">
                      STT
                      <br />
                      <span className="color-do-bold">
                        [{listQuanLyThuChiHopDongFull.TotalQuantity}]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-8 flex-mobile-10 center-flex">
                    <p>Thời gian</p>
                  </div>
                  <div className="custom-table-header flex-basis-8 flex-mobile-12">
                    <p>Nhân viên</p>
                  </div>
                  <div className="custom-table-header center-flex flex-basis-9 flex-mobile-12">
                    <p>Mã Hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-9 flex-mobile-12">
                    <p>Tên khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-mobile-10">
                    <p>CMND</p>
                  </div>
                  <div className="custom-table-header flex-basis-6 flex-mobile-12">
                    <p className="text-left">Loại</p>
                  </div>
                  {batHinhThucThanhToan && (
                    <div className="custom-table-header flex-basis-8 flex-mobile-12">
                      <p className="text-left">Hình thức thanh toán</p>
                    </div>
                  )}
                  <div className="custom-table-header flex-basis-10 flex-mobile-15">
                    <p className="text-right">
                      Thu
                      <br />
                      <span
                        className="color-xanh-bold"
                        title={formatNumber(
                          listQuanLyThuChiHopDongFull.TotalTienThu
                        )}
                      >
                        {formatCurrency2(
                          listQuanLyThuChiHopDongFull.TotalTienThu
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-mobile-15">
                    <p className="text-right">
                      Chi
                      <br />
                      <span
                        className="color-do-bold"
                        title={formatNumber(
                          listQuanLyThuChiHopDongFull.TotalTienChi
                        )}
                      >
                        {formatCurrency2(
                          listQuanLyThuChiHopDongFull.TotalTienChi
                        )}
                      </span>
                    </p>
                  </div>
                  {(listQuanLyThuChiHopDongFull.IsPhiKho === 1 ||
                    listQuanLyThuChiHopDongFull.TotalPhiKho > 0) && (
                    <div className="custom-table-header flex-basis-9 flex-mobile-13">
                      <p className="text-right">
                        Phí kho
                        <br />
                        <span className="color-xanh-bold">
                          {formatNumber(
                            listQuanLyThuChiHopDongFull.TotalPhiKho
                          )}
                        </span>
                      </p>
                    </div>
                  )}

                  <div className="custom-table-header flex-basis-9 flex-mobile-13">
                    <p className="text-right">
                      Phí khác
                      <br />
                      <span className="color-xanh-bold">
                        {formatNumber(listQuanLyThuChiHopDongFull.TotalPhiKhac)}
                      </span>
                    </p>
                  </div>
                  {(isDuDungPhiPhatDongLaiTatToan ||
                    isSuDungPhiPhatDongLaiCham ||
                    isWinmoney) && (
                    <>
                      <div className="custom-table-header flex-basis-9 flex-mobile-13">
                        <p className="text-right">
                          Phạt chậm đóng lãi
                          <br />
                          <span className="color-xanh-bold">
                            {/* Tổng phải lấy đúng cột mà từng dòng đang hiện:
                                PhiPhatDongLai hay PhiDongLaiCham */}
                            {formatNumber(
                              isDuDungPhiPhatDongLaiTatToan
                                ? listQuanLyThuChiHopDongFull.TotalPhiPhatDongLai
                                : listQuanLyThuChiHopDongFull.TotalPhiDongLaiCham
                            )}
                          </span>
                        </p>
                      </div>
                    </>
                  )}

                  {(isDuDungPhiPhatDongLaiTatToan || SuDungTatToanSom) && (
                    <div className="custom-table-header flex-basis-9 flex-mobile-13">
                      <p className="text-right">
                        Phạt tất toán sớm
                        <br />
                        <span className="color-xanh-bold">
                          {formatNumber(
                            listQuanLyThuChiHopDongFull.TotalPhiPhatTatToan
                          )}
                        </span>
                      </p>
                    </div>
                  )}
                  {(listQuanLyThuChiHopDongFull.IsHoaHongTraGop !== "0" ||
                    listQuanLyThuChiHopDongFull.TotalPhiPhat > 0) && (
                    <>
                      <div className="custom-table-header flex-basis-9 flex-mobile-13">
                        <p className="text-right">
                          Phí phạt
                          <br />
                          <span className="color-xanh-bold">
                            {formatNumber(
                              listQuanLyThuChiHopDongFull.TotalPhiPhat
                            )}
                          </span>
                        </p>
                      </div>
                      <div className="custom-table-header flex-basis-9 flex-mobile-13">
                        <p className="text-right">
                          Phí hoa hồng
                          <br />
                          <span className="color-xanh-bold">
                            {formatNumber(
                              listQuanLyThuChiHopDongFull.TotalPhiHoaHong
                            )}
                          </span>
                        </p>
                      </div>
                    </>
                  )}

                  <div className="custom-table-header-thu-lai flex-basis-27 flex-mobile-39">
                    <table
                      className="content_table"
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            colSpan="3"
                            style={{
                              textAlign: "center",
                              borderBottom: "1px solid #e3ebf3",
                            }}
                            className="color7-bold"
                          >
                            Thu lãi
                          </th>
                        </tr>
                        <tr>
                          <th
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                            }}
                            className="color7-bold"
                          >
                            Tiền gốc
                          </th>
                          <th
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                            }}
                            className="color7-bold"
                          >
                            Tiền lãi
                          </th>
                          <th
                            style={{
                              textAlign: "right",
                              paddingRight: "10px",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                            }}
                            className="color7-bold"
                          >
                            Các loại phí
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                              fontSize: "13px",
                            }}
                            className="color-cam-bold"
                          >
                            <span
                              title={formatNumber(
                                listQuanLyThuChiHopDongFull.TotalValueGoc
                              )}
                            >
                              {formatNumber(
                                listQuanLyThuChiHopDongFull.TotalValueGoc
                              )}
                            </span>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                              fontSize: "13px",
                            }}
                            className="color-xanh-bold"
                          >
                            <span
                              title={formatNumber(
                                listQuanLyThuChiHopDongFull.TotalValueLai
                              )}
                            >
                              {formatNumber(
                                listQuanLyThuChiHopDongFull.TotalValueLai
                              )}
                            </span>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                              fontSize: "13px",
                            }}
                            className="color-do-bold"
                          >
                            <span
                              title={formatNumber(
                                listQuanLyThuChiHopDongFull.TotalOtheFeeHangKy
                              )}
                            >
                              {formatNumber(
                                listQuanLyThuChiHopDongFull.TotalOtheFeeHangKy
                              )}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="custom-table-header flex-basis-9 flex-mobile-8 action-cell">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body ">
                  <ContentTable
                    listQuanLyThuChiHopDong={listQuanLyThuChiHopDongFull.List}
                    daDoc={daDoc}
                    inPhieuChi={inPhieuChi}
                    inPhieuThu={inPhieuThu}
                    suaPhieu={suaPhieu}
                    xoaPhieu={xoaPhieu}
                    isHoaHongTraGop={isHoaHongTraGop}
                    isDuDungPhiPhatDongLaiTatToan={
                      isDuDungPhiPhatDongLaiTatToan
                    }
                    isSuDungPhiPhatDongLaiCham={isSuDungPhiPhatDongLaiCham}
                    SuDungTatToanSom={SuDungTatToanSom}
                    isWinmoney={isWinmoney}
                    batHinhThucThanhToan={batHinhThucThanhToan}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
          marginTop: "-25px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {TotalQuantity === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.pageIndex * dataSearch.pageSize,
                      TotalQuantity
                    )}{" "}
                    / Tổng số {TotalQuantity}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (TotalQuantity === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
